const AlgebraLatex = require('algebra-latex')
var coffeequate = require('coffeequate')
// var algebrite = require('algebrite')
// var algebraJS = require('algebra.js')

export const unwrap = (str) => {
  str = str.trim()
  str = str.slice(0, -2)
  str = str.slice(2, str.length)

  return str
}

export const unwrap2 = (str) => {
  // str = str.trim()
  // eslint-disable-next-line
  let arr = str.match(/\$\$(.*)\$\$/)
  if (arr && arr.length === 2 && arr[1]) {
    return arr[1]
  } else {
    return str.replace('$$', '').replace('$$', '')
  }
}

export const compareIsEqualByKanKAS = ({ a, b, onError = () => {}, equavalents = {} }) => {
  let _ = require('underscore')
  console.log()
  window._ = _
  _.contains = _.includes
  let KAS = window.KAS
  console.log(a)
  console.log(b)

  a = unwrap2(a)
  b = unwrap2(b)

  var result = false
  try {
    var parsedA = KAS.parse(a, {}).expr
    var parsedB = KAS.parse(b, {}).expr

    console.log(parsedA)
    console.log(parsedB)

    result = KAS.compare(parsedA, parsedB).equal

    console.log('Printed Representation A:', parsedA.normalize().print())
    console.log('TeX Representation A:', parsedA.tex())
    //
    console.log('Simplified A:', parsedA.simplify().normalize().print())
    //
    console.log('Printed Representation B:', parsedB.normalize().print())
    console.log('TeX Representation B:', parsedB.tex())
    //
    console.log('Simplified B:', parsedB.simplify().normalize().print())
  } catch (e) {
    onError(e)
    console.log(e)
    return false
  }

  return result
}

export const compareIsEqual = (args) => {
  return compareIsEqualByKanKAS(args)
}

export const compareIsEqualOld = ({ a, b, equavalents = {}, onError }) => {
  // remvoe the $$
  a = unwrap(a)
  // remvoe the $$
  b = unwrap(b)

  //

  try {
    let algebraObjA = new AlgebraLatex().parseLatex(a).toCoffeequate(coffeequate)
    let algebraObjB = new AlgebraLatex().parseLatex(b).toCoffeequate(coffeequate)

    if (algebraObjA.equals(algebraObjB, equavalents)) {
      return true
    } else {
      return false
    }
  } catch (e) {
    console.error(e)
    onError(e)
    return false
  }
}

